import {
  createScheduleSchema,
  projectAutomationLimitsSchema,
  updateProjectAutomationLimitsSchema,
  type UpdateProjectAutomationLimits,
  createTriggerSchema,
  deliveryListSchema,
  deliverySchema,
  projectSettingsSchema,
  scheduleListSchema,
  scheduleSchema,
  triggerListSchema,
  triggerSchema,
  type CreateSchedule,
  type CreateTrigger,
} from "@zworks/console-contracts";
import { apiGet, apiPost, apiPut } from "./api";
const path = (projectId: string) => `/api/v1/projects/${encodeURIComponent(projectId)}`;
export const schedulesQuery = (id: string) => ({
  queryKey: ["projects", id, "schedules"],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    apiGet(`${path(id)}/schedules`, scheduleListSchema, signal),
  refetchInterval: 20000,
});
export const triggersQuery = (id: string) => ({
  queryKey: ["projects", id, "triggers"],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    apiGet(`${path(id)}/triggers`, triggerListSchema, signal),
  refetchInterval: 20000,
});
export const deliveriesQuery = (id: string) => ({
  queryKey: ["projects", id, "deliveries"],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    apiGet(`${path(id)}/deliveries`, deliveryListSchema, signal),
  refetchInterval: 20000,
});
export const automationSettingsQuery = (id: string) => ({
  queryKey: ["projects", id, "settings"],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    apiGet(`${path(id)}/settings`, projectSettingsSchema, signal),
});
export const automationLimitsQuery = (id: string) => ({
  queryKey: ["projects", id, "automation-limits"],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    apiGet(`${path(id)}/automation/limits`, projectAutomationLimitsSchema, signal),
});
export const saveAutomationLimits = (id: string, input: UpdateProjectAutomationLimits) =>
  apiPut(
    `${path(id)}/automation/limits`,
    projectAutomationLimitsSchema,
    updateProjectAutomationLimitsSchema.parse(input),
  );
export const createSchedule = (id: string, input: CreateSchedule) =>
  apiPost(`${path(id)}/schedules`, scheduleSchema, createScheduleSchema.parse(input));
export const createTrigger = (id: string, input: CreateTrigger) =>
  apiPost(`${path(id)}/triggers`, triggerSchema, createTriggerSchema.parse(input));
export const changeScheduleState = (id: string, ruleId: string, action: "pause" | "resume") =>
  apiPost(`${path(id)}/schedules/${encodeURIComponent(ruleId)}/${action}`, scheduleSchema);

export const retryDelivery = (id: string, deliveryId: string) =>
  apiPost(`${path(id)}/deliveries/${encodeURIComponent(deliveryId)}/retry`, deliverySchema);
